import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { createContext, useContext } from "react";

/**
 * Create a side-effect-free context provider.
 */
var BannerContextFactory = /*#__PURE__*/function () {
  function BannerContextFactory() {
    _classCallCheck(this, BannerContextFactory);
  }

  _createClass(BannerContextFactory, null, [{
    key: "Context",
    value: function (_Context) {
      function Context() {
        return _Context.apply(this, arguments);
      }

      Context.toString = function () {
        return _Context.toString();
      };

      return Context;
    }(function () {
      return this.context = this.context || /*#__PURE__*/createContext({});
    })
  }]);

  return BannerContextFactory;
}();

BannerContextFactory.context = void 0;

function useBanner() {
  return useContext(BannerContextFactory.Context());
}

export { BannerContextFactory, useBanner };